import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, LifeBuoy, CheckCircle2 } from 'lucide-react';
import PortalTopBar from '../../components/academy/PortalTopBar';
import { useAuth, formatApiError } from '../../context/AuthContext';

export default function TechSupport() {
  const { api } = useAuth();
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/api/academy/my/tickets', { subject, message });
      setDone(true);
      setSubject(''); setMessage('');
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PortalTopBar />
      <main className="max-w-[760px] mx-auto px-4 lg:px-6 py-8">
        <Link to="/academy/dashboard" className="inline-flex items-center gap-1.5 text-[13px] text-[#6E6E73] hover:text-[#c9a227] mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Dashboard
        </Link>
        <div className="flex items-center gap-3 mb-1">
          <LifeBuoy className="w-7 h-7 text-[#c9a227]" />
          <h1 className="text-[28px] font-extrabold text-[#1D1D1F]">Technical Support</h1>
        </div>
        <p className="text-[14px] text-[#6E6E73] mb-6">Open a ticket and our Academy team will get back within one business day.</p>

        <div className="rounded-2xl border border-[#E5E5E7] bg-white p-6">
          {done && (
            <div className="rounded-lg bg-emerald-50 border border-emerald-200 px-4 py-3 mb-5 flex items-center gap-2 text-[14px] text-emerald-700">
              <CheckCircle2 className="w-5 h-5" /> Your ticket has been submitted.
            </div>
          )}
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-[11px] font-bold tracking-[0.18em] uppercase text-[#6E6E73] mb-1.5">Subject</label>
              <input
                type="text" required value={subject} onChange={(e) => setSubject(e.target.value)}
                data-testid="ticket-subject"
                className="w-full px-4 py-2.5 rounded-lg border border-[#E5E5E7] focus:border-[#c9a227] focus:ring-2 focus:ring-[#c9a227]/30 outline-none"
                placeholder="What can we help with?"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold tracking-[0.18em] uppercase text-[#6E6E73] mb-1.5">Message</label>
              <textarea
                required value={message} onChange={(e) => setMessage(e.target.value)} rows={6}
                data-testid="ticket-message"
                className="w-full px-4 py-2.5 rounded-lg border border-[#E5E5E7] focus:border-[#c9a227] focus:ring-2 focus:ring-[#c9a227]/30 outline-none resize-y"
                placeholder="Describe your issue with as much detail as possible…"
              />
            </div>
            {error && <div className="text-red-600 text-[13px]">{error}</div>}
            <button
              type="submit" disabled={loading}
              data-testid="ticket-submit"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-[14px] font-bold uppercase tracking-[0.18em] text-[#0e0e10] disabled:opacity-60"
              style={{ background: 'linear-gradient(90deg,#e6c35a,#c9a227,#a8871a)' }}
            >
              {loading ? 'Sending…' : 'Submit ticket'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
